import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WhereToVoteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"where_to_vote"}/>
}
